export const upgradePlanModalId = 'upgrade-plan';
